import { loc, internal } from '../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js';
import oktaUnderscore from '../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js';
import '../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js';
import FormController from '../util/FormController.js';
import Footer from '../views/enroll-factors/Footer.js';

/*!
 * Copyright (c) 2018-2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
const {
  Util: Util
} = internal.util;
var EnrollCustomFactorController = FormController.extend({
  className: 'enroll-custom-factor',
  Model: {
    local: {
      provider: 'string',
      factorType: 'string'
    },
    save: function () {
      return this.manageTransaction((transaction, setTransaction) => {
        const factor = oktaUnderscore.findWhere(transaction.factors, {
          provider: this.get('provider'),
          factorType: this.get('factorType')
        });
        return factor.enroll().then(trans => {
          setTransaction(trans);
          const url = this.appState.get('enrollCustomFactorRedirectUrl');
          if (url !== null) {
            Util.redirect(url);
          }
        }).catch(function (err) {
          throw err;
        });
      });
    }
  },
  Form: function () {
    const factors = this.options.appState.get('factors');
    const factor = factors.findWhere({
      provider: this.options.provider,
      factorType: this.options.factorType
    });
    const vendorName = factor.get('vendorName');
    const subtitle = loc('enroll.customFactor.subtitle', 'login', [vendorName]);
    const saveText = loc('enroll.customFactor.save', 'login');
    return {
      autoSave: true,
      title: vendorName,
      subtitle: subtitle,
      save: saveText
    };
  },
  trapAuthResponse: function () {
    if (this.options.appState.get('isMfaEnrollActivate')) {
      return true;
    }
  },
  initialize: function () {
    this.model.set('provider', this.options.provider);
    this.model.set('factorType', this.options.factorType);
  },
  Footer: Footer
});

export { EnrollCustomFactorController as default };
//# sourceMappingURL=EnrollCustomFactorController.js.map
